import React, { useEffect, useState } from 'react';
import { TextField, InputAdornment, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Box, CircularProgress, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { RenderParticipantName } from './Elements';
import { fetchParticipants, Participant } from '../api/contests';
import ClearIcon from '@mui/icons-material/Clear';

const Participants: React.FC = () => {
  const [participants, setParticipants] = useState<Participant[]>([]);
  const [filteredParticipants, setFilteredParticipants] = useState<Participant[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const loadParticipants = async () => {
      try {
        const data = await fetchParticipants();
        setParticipants(data);
        setFilteredParticipants(data);
      } catch (error) {
        console.error('Error fetching participants:', error);
      }
    };
    loadParticipants();
  }, []);

  useEffect(() => {
    const filtered = participants.filter((participant) =>
        participant.name?.toLowerCase()?.includes(searchTerm.toLowerCase())
    );
    setFilteredParticipants(filtered);
  }, [searchTerm, participants]);

  const handleClearSearch = () => {
    setSearchTerm('');
  };

  return !participants.length ? (
      <Box display="flex" justifyContent="center" mt={2}>
        <CircularProgress />
      </Box>
  ) : (
      <Box>
        <TextField
            label="Найти участника"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            variant="outlined"
            fullWidth
            margin="normal"
            InputProps={{
              endAdornment: (
                  <InputAdornment position="end">
                    {searchTerm && (
                        <IconButton onClick={handleClearSearch}>
                          <ClearIcon />
                        </IconButton>
                    )}
                  </InputAdornment>
              ),
            }}
        />

        {/* Scrollable container for the table */}
        <Box component={Paper} sx={{ overflowX: 'auto', maxWidth: '100%', marginTop: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Имя</TableCell>
                <TableCell>Возраст</TableCell>
                <TableCell>Пол</TableCell>
                <TableCell>Возрастная группа</TableCell>
                <TableCell>Количество заруб</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredParticipants.map((participant, index) => (
                  <TableRow key={participant.participant_id}>
                    <TableCell>
                      {RenderParticipantName(participant.participant_id, participant.name, participant.profile_picture, true)}
                    </TableCell>
                    <TableCell>{participant.age ?? '-'}</TableCell>
                    <TableCell>{participant.gender}</TableCell>
                    <TableCell>{participant.age_group_name}</TableCell>
                    <TableCell>{participant.total_entries}</TableCell>
                  </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Box>
  );
};

export default Participants;
